<template>
  <div class="sm_user">
    <template v-if="!memberData">
      <div class="user shimmer-skeleton avatar-skeleton"></div>
      <div class="user-info-wrapper">
        <div class="user-info-text__wrapper">
          <div class="shimmer-skeleton text-skeleton name"></div>
          <div class="shimmer-skeleton text-skeleton duty"></div>
        </div>
        <div class="shimmer-skeleton tier-skeleton"></div>
      </div>
      <div class="opt">
        <ul>
          <li class="opt-box" v-for="n in 3" :key="n">
            <div class="shimmer-skeleton text-skeleton box-title"></div>
            <div class="shimmer-skeleton text-skeleton box-content"></div>
          </li>
        </ul>
      </div>
    </template>

    <template v-else-if="memberData">
      <!-- 프로필 카드 - 유저 정보 -->
      <div class="user">
        <div
          class="overflow-visible img img-relative background-size-cover"
          v-if="memberData.member.profile"
          :style="`background: url(${
            memberData.member.profile.resourceUri &&
            memberData.member.profile.resourceUri.length > 0
              ? memberData.member.profile.resourceUri
              : 'images/avatar_image.png'
          }) center`"
        >
          <span class="overflow-visible position-relative">
            <ProfileTier :data="memberData.member" />
          </span>
        </div>
        <div
          class="overflow-visible img img-relative background-size-cover"
          v-else
        >
          <span>
            <ProfileTier :data="memberData.member" />
          </span>
        </div>
      </div>

      <!-- 유저 이름, 직책 -->
      <div class="user-info-wrapper">
        <div
          class="user-info-text__wrapper"
          :class="{
            'full-width':
              !memberData.member.tier ||
              (memberData.member.tier && !memberData.member.tier.name),
          }"
        >
          <div class="user-info-name">
            {{
              memberData.member.name
                ? memberData.member.name.last +
                  " " +
                  memberData.member.name.first
                : ""
            }}
          </div>

          <div class="user-info-responsibility">
            {{ `${dutyName} > ${responsibilityName}` }}
          </div>
        </div>

        <div
          class="tier-wrapper"
          v-if="
            memberData.member.tier &&
            memberData.member.tier.name &&
            memberData.member.tier.name !== '-'
          "
        >
          {{ memberData.member.tier.name }}
        </div>
      </div>

      <!-- 프로필카드 - 수치 -->
      <div class="opt">
        <ul>
          <li class="opt-box">
            <div class="opt-box__title">{{ $t("S10000") }}</div>
            <div class="opt-box__content">
              {{ memberData.learner.completion }} /
              {{ memberData.learner.learning }}
            </div>
          </li>
          <li class="opt-box">
            <div class="opt-box__title">{{ $t("S10001") }}</div>
            <div class="opt-box__content">{{ memberPoints }}</div>
          </li>
          <li class="opt-box">
            <div class="opt-box__title">{{ $t("S10002") }}</div>
            <div class="opt-box__content">{{ memberRank }}</div>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import ProfileTier from "@/components/common/ProfileTier.vue";

export default {
  name: "MainUserProfile",

  props: [
    "memberData",
    "memberPoints",
    "memberRank",
    "responsibilityName",
    "dutyName",
  ],

  components: {
    ProfileTier,
  },
};
</script>

<style scoped>
.sm_user {
  position: relative;
  z-index: 1;
  border-radius: 8px;
  background: transparent;
  margin-top: -35px;

  display: flex;
  flex-direction: column;
  justify-content: center;
}
.sm_user .user {
  display: flex;
  align-items: flex-start;
}

.sm_user .user .img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  position: relative;
  display: inline-block;
  aspect-ratio: 1/1;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
}
.sm_user .user .img span {
  border-radius: 50%;
  overflow: hidden;
  width: 100%;
  height: 100%;
  border: 4px solid #fff;
  display: block;
  text-align: center;
  position: relative;
}
.sm_user .user .img span img {
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
}
.user-info-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  /* padding-right: 10px; */
}
.user-info-text__wrapper {
  max-width: 60%;
}
.user-info-name {
  font-size: 18px;
  font-weight: bold;
  color: #212121;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-info-responsibility {
  margin-top: 4px;
  font-size: 12px;
  color: #505050;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tier-wrapper {
  min-width: 64px;
  max-width: 120px;
  max-height: 36px;
  padding: 12px 10px;

  border-radius: 4px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
  /* background: linear-gradient(90deg, #4c8dee 0%, #2d6dcc 70%); */
  /* color:white; */
  background: #e9f0fa;
  color: #2d6dcc;

  text-align: center;
  line-height: 14px;
  font-size: 12px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sm_user .user .name {
  position: relative;
  color: #2d6dcc;
  font-size: 16px;
  font-weight: bold;
  color: #212121;
}
.responsibility {
  font-size: 12px !important;
  font-weight: 400 !important;
  color: #505050 !important;
}
.sm_user .opt {
  position: relative;
  text-align: center;
  margin-top: 24px;
}
.sm_user .opt ul {
  position: relative;
  font-size: 0;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.opt-box {
  width: 33%;
  padding: 13px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  background-color: #ffffff;
}
.opt-box__title {
  font-size: 12px;
  font-weight: 500;
  color: #acb4be;
}
.opt-box__content {
  font-size: 16px;
  font-weight: bold;
  color: #505050;
}

.shimmer-skeleton {
  background: #f0f0f0;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}
.shimmer-skeleton::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shimmer 1.2s infinite;
}
@keyframes shimmer {
  100% {
    left: 100%;
  }
}

/* Skeleton shapes */
.avatar-skeleton {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-bottom: 10px;
}
.text-skeleton.name {
  width: 150px;
  height: 18px;
  margin-bottom: 8px;
}
.text-skeleton.duty {
  width: 120px;
  height: 12px;
}
.tier-skeleton {
  width: 80px;
  height: 24px;
  margin-left: auto;
}
.box-title {
  width: 60px;
  height: 12px;
  margin-bottom: 4px;
}
.box-content {
  width: 40px;
  height: 16px;
}
</style>